"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMap = selectMap;
exports.selectActiveMap = selectActiveMap;
exports.selectMapIdList = selectMapIdList;
exports.selectMapList = selectMapList;
exports.selectActiveMapId = selectActiveMapId;
exports.selectIsAllMapsPlayed = selectIsAllMapsPlayed;

var _constants = require("../constants");

function selectModule(state) {
  return state[_constants.MAP_MODULE_NAME];
}

function selectMapState(state) {
  return selectModule(state).map;
}

function selectMapList(state) {
  return selectMapState(state).data;
}

function selectIsAllMapsPlayed(state) {
  return !Object.values(selectMapList(state)).some(function (map) {
    return 'NOT_PLAYED' === map.status;
  });
}

function selectMapIdList(state) {
  return selectMapState(state).list;
}

function selectMap(state, id) {
  return selectMapList(state)[id];
}

function selectActiveMapId(state) {
  return selectMapState(state).activeMapId;
}

function selectActiveMap(state) {
  var activeMapId = selectActiveMapId(state);
  return selectMap(state, activeMapId);
}